import Vue from 'vue';
import Tooltip from '../Tooltips/Tooltip.vue';
import { invokeOrIdentity } from 'src/utils';
export default Vue.extend({
    name: 'Button',
    components: {
        Tooltip
    },
    props: {
        substrate: { type: Object },
        buttonProps: { type: Object },
        tooltipProps: {
            type: Object
        },
        buttonListeners: {
            type: Object
        },
    },
    computed: {
        isHidden() {
            var _a;
            return invokeOrIdentity((_a = this.buttonProps) === null || _a === void 0 ? void 0 : _a.isHidden) || false;
        }
    },
    methods: {
        onClick(event) {
            this.$emit('click', event);
        },
        invokeOrIdentity
    },
});
